var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 214,
    viewBox: "0 0 150 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 0C33.5357 0 0 33.491 0 74.9C0 93.518 5.35714 110.959 15.1071 126.688C25.2857 143.166 38.6786 157.29 48.9643 173.768C54 181.793 57.6429 189.283 61.5 197.95C64.2857 203.835 66.5357 214 75 214C83.4643 214 85.7143 203.835 88.3929 197.95C92.3571 189.283 95.8929 181.793 100.929 173.768C111.214 157.397 124.607 143.273 134.786 126.688C144.643 110.959 150 93.518 150 74.9C150 33.491 116.464 0 75 0Z",
    fill: "#2A5BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlue);
export default __webpack_public_path__ + "static/media/marker-blue.3b151e56093f9193237d7de8e71c7a7c.svg";
export { ForwardRef as ReactComponent };